module.exports = __webpack_public_path__ + "img/eo-heimat.3a0a3533.svg";